export const appSettingsCustomAttributeUsage = "/app_settings/custom_attribute_usage";
